import React from "react";

export const getStatusIcon = (
  status: "in-progress" | "succeeded" | "failed" | "aborted",
) => {
  switch (status) {
    case "succeeded":
      return (
        <div className="size-4 flex flex-col items-center justify-center">
          <img
            src="/icons/ai-chat-status/success.svg"
            className="size-4 shrink-0 flex"
            alt="Success"
          />
        </div>
      );
    case "failed":
      return (
        <div className="size-4 flex flex-col items-center justify-center">
          <img
            src="/icons/ai-chat-status/failed.svg"
            className="size-4 shrink-0"
            alt="Failed"
          />
        </div>
      );
    case "aborted":
      return (
        <div className="size-4 flex flex-col items-center justify-center">
          <img
            src="/icons/ai-chat-status/failed.svg"
            className="size-4 shrink-0"
            alt="Aborted"
          />
        </div>
      );
    default:
      return (
        <div className="size-4 flex flex-col items-center justify-center">
          <img
            src="/icons/ai-chat-status/progress.svg"
            className="size-4 shrink-0 flex animate-pulse"
            alt="In Progress"
          />
        </div>
      );
  }
};
